import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { Flex, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.25);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
`

const FullLoading = ({ loading }) => {
  if (!loading) return null

  return (
    <Overlay>
      <Flex
        alignItems="center"
        height="100%"
        justifyContent="center"
        m="auto"
        width="100%"
      >
        <FontAwesomeIcon fontSize="48px" icon={faSpinner} spin />
      </Flex>
    </Overlay>
  )
}

const mapStateToProps = (state) => {
  return {
    loading: state.client.fullLoading,
  }
}

FullLoading.propTypes = {
  loading: PropTypes.bool,
}

export default connect(mapStateToProps)(FullLoading)
